module.exports = __webpack_public_path__ + "img/adf2.1bf462cc.png";